/* eslint-disable no-alert */
import React, { useState } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';

export const RadioTextBox = (props) => {
  const [radioValue, setRadioValue] = useState('');
  const [question] = useState(props);
  const [focusOnTextBox, setFocusOnTextBox] = useState(false);
  question?.qstn?.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });

  const optionValuesArray: string[] = [];
  question?.qstn?.options.map((opt, i) => {
    return optionValuesArray.push(opt.values[0].id);
  });

  return (
    <React.Fragment>
      <div key={question?.qstn?.questionId}>
        <RadioGroup
          label={<strong>{`${question.serial}. ${question.qstn?.questionText}`}</strong>}
          value={radioValue}
          model={`qstn-${question?.qstn?.questionId}`}
          key={`radiotb-${question?.qstn?.questionId}`}
          validators={{ required: 'Please select an option' }}
          onChange={(e) => {
            if (
              optionValuesArray.indexOf(e.target.value) >= 0 &&
              focusOnTextBox == false
            ) {
              return setRadioValue(e.target.value);
            }
          }}
        >
          <RadioGroup.Column>
          {question.qstn?.options.map((opt, idx) => {
            return (
              <div
                key={`radio-${question?.qstn?.questionId}-${idx}`}
                style={{ marginTop: '8px' }}
              >
                <RadioGroup.Radio
                  label={opt.values[0].value}
                  value={opt.values[0].id}
                  key={opt.id}
                />
                {opt.values[0]['additional text'] != undefined &&
                radioValue === opt.values[0].id ? (
                  <TextInput
                    id="textarea"
                    key={`text-${question?.qstn?.questionId}`}
                    model={`text-${question?.qstn?.questionId}`}
                    hideLabel
                    onFocus={() => {
                      setFocusOnTextBox(true);
                    }}
                    onBlur={() => {
                      setFocusOnTextBox(false);
                    }}
                    isClearable
                    validators={{
                      required: 'Please enter at least 4 characters',
                      minLength: {
                        value: 4,
                        message: 'Please enter at least 4 characters',
                      },
                    }}
                  />
                ) : null}
              </div>
            );
          })}
          </RadioGroup.Column>
        </RadioGroup>
      </div>
    </React.Fragment>
  );
};
